import {
    MessageBar,
    Spinner,
    SpinnerSize,
} from '@fluentui/react';
import Toast from '../../Forms/Toast';

const GoogleAnlyticsNotifications = ({showToast, setShowToast, toastMessage, generationStatus, setGenerationStatus, loadingSetupGa}) => {

    return (
        <div>
            <Toast show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
            {loadingSetupGa && <Spinner size={SpinnerSize.large} label="Generating GA Data..." />}
            {generationStatus.message && (
                <MessageBar messageBarType={generationStatus.type} isMultiline={false} onDismiss={() => setGenerationStatus({ message: '', type: null })} dismissButtonAriaLabel="Close" style={{ marginTop: '15px' }}>
                    {generationStatus.message}
                </MessageBar>
            )}
        </div>
    )
}
export default GoogleAnlyticsNotifications;